export const state = {
  autologin: false,
};

export const mutations = {
  SET_AUTOLOGIN(state, autologin) {
    state.autologin = autologin;
  },
};
